import { createElement } from "react";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";

// Parse HTML first, then sanitize the resulting tree rather than the Markdown text.
export const safeMarkdownSchema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    img: ["src", "alt", "title", "width", "height"],
    span: [...(defaultSchema.attributes?.span ?? []), ["className", "bg-yellow-300"]],
  },
  protocols: { ...defaultSchema.protocols, src: ["http", "https"] },
};

export const safeMarkdownPlugins = [rehypeRaw, [rehypeSanitize, safeMarkdownSchema]];

export const safeMarkdownComponents = {
  // Deliberately permit images from any host, without forwarding the page referrer.
  img: ({ src, alt, title, width, height }) => createElement("img", {
    // Set request policy before src: React 18 assigns DOM properties in this order.
    referrerPolicy: "no-referrer", loading: "lazy", alt, title, width, height, src,
  }),
};
